import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-role-alter",
  "use": "icon-role-alter-usage",
  "viewBox": "0 0 10 9.969",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 9.969\" id=\"icon-role-alter\">\r\n  <defs>\r\n    <style>\r\n      #icon-role-alter .cls-1 {\r\n        fill: #40a9ff;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-role-alter_编辑_拷贝\" data-name=\"编辑 拷贝\" class=\"cls-1\" d=\"M745.427,216.119l-0.519.522a0.41,0.41,0,0,0,0,.577l1.86,1.871a0.4,0.4,0,0,0,.572,0l0.519-.522a0.409,0.409,0,0,0,0-.576L746,216.119A0.4,0.4,0,0,0,745.427,216.119Zm-6.093,6.71,1.859,1.872a0.4,0.4,0,0,0,.573,0l4.457-4.487a0.409,0.409,0,0,0,0-.576l-1.86-1.872a0.4,0.4,0,0,0-.572,0l-4.457,4.487A0.407,0.407,0,0,0,739.334,222.829Zm-0.287-.288-0.275.821,1.885,1.9a0.207,0.207,0,0,1-.108.35l-2.071.385a0.407,0.407,0,0,1-.47-0.483l0.417-2.045A0.205,0.205,0,0,1,738.772,223.362Z\" transform=\"translate(-738 -216.031)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/role-alter.svg
// module id = VrWJ
// module chunks = 127